export class TypeOuiNon {

	public oui: boolean;

	public non: boolean;

	constructor() { 
		 		this.oui = true;
		this.non = true;
 
	}
}
